export type Alphabet = string;
export type CharactersCount = number;

export type Config = {
  alphabet: Alphabet;
  strength: CharactersCount;
};

export const defaultConfig: Config = {
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  strength: 15,
};
